import { useEffect, useMemo, useState } from "react";
import SalesAvailabilityApi from "../../api/SalesAvailabilityApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Availability.css";

function MyAvailability() {
  const [date, setDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });
  const [manualSlots, setManualSlots] = useState([]);
  const [isHoliday, setIsHoliday] = useState(false);
  const [meetingSlots, setMeetingSlots] = useState([]);

  const navigate = useNavigate();

  const allSlots = useMemo(() => {
    return [
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
    ];
  }, []);
  useEffect(() => {
    if (date) {
      loadAvailability(date);
    }
  }, [date]);

  const loadAvailability = async (value) => {
    try {
      const res = await SalesAvailabilityApi.get(value);

      if (res.code === 200 && res.data) {
        setManualSlots(res.data.manualSlots || []);

        setMeetingSlots(res.data.meetingSlots || []);
        setIsHoliday(res.data.isHoliday || false);
      } else {
        setManualSlots([]);
        setMeetingSlots([]);
      }
    } catch {
      setManualSlots([]);
      setMeetingSlots([]);
      setIsHoliday(false);
    }
  };

  const toggleSlot = (slot) => {
    const meeting = meetingSlots.find((x) => x.time === slot);

    if (meeting) {
      navigate(`/lead-details/${meeting.leadMongoId}`);
      return;
    }

    if (manualSlots.includes(slot)) {
      setManualSlots(manualSlots.filter((x) => x !== slot));
    } else {
      setManualSlots([...manualSlots, slot]);
    }
  };

  const availableSlots =
    allSlots.length -
    new Set([...manualSlots, ...meetingSlots.map((x) => x.time)]).size;

  const busySlots = new Set([
    ...manualSlots,
    ...meetingSlots.map((x) => x.time),
  ]).size;

  const save = async () => {
    if (!date) {
      return toast.error("Please select date");
    }

    await SalesAvailabilityApi.save({
      date,
      slots: manualSlots,
      isHoliday,
    });

    toast.success("Availability Saved");
  };

  const morning = ["09:30", "10:00", "10:30", "11:00", "11:30"];

  const afternoon = [
    "12:00",
    "12:30",
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
  ];

  const evening = ["05:00", "05:30", "06:00", "06:30"];

  const renderSection = (title, slots) => (
    <div className="availability-section">
      <div className="section-header">
        <div className="section-title">
          <div className="section-icon">
            {title === "Morning" && <i className="ti ti-sunrise"></i>}

            {title === "Afternoon" && <i className="ti ti-sun"></i>}

            {title === "Evening" && <i className="ti ti-moon-stars"></i>}
          </div>

          <div>
            <h4>{title}</h4>

            <span>{slots.length} Slots</span>
          </div>
        </div>
      </div>

      <div className="slot-grid">
        {slots.map((slot) => {
          const manualBusy = manualSlots.includes(slot);

          const meetingBusy = meetingSlots.find((x) => x.time === slot);

          const tooltip = meetingBusy
            ? `
Lead ID : ${meetingBusy.leadId}

Customer : ${meetingBusy.customer}

Phone : ${meetingBusy.phone}

Status : ${meetingBusy.status}
`
            : "";

          return (
            <button
              key={slot}
              title={tooltip}
              disabled={isHoliday}
              onClick={() => toggleSlot(slot)}
              className={`slot-card

            ${
              isHoliday
                ? "slot-holiday"
                : meetingBusy
                  ? "slot-meeting"
                  : manualBusy
                    ? "slot-busy"
                    : "slot-free"
            }

            `}
            >
              <div className="slot-time">{slot}</div>

              <div className="slot-status">
                {meetingBusy ? "Meeting" : manualBusy ? "Blocked" : "Available"}
              </div>

              {meetingBusy && (
                <div className="meeting-indicator">
                  <i className="ti ti-calendar-event"></i>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="">
      <div className="content">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="availability-header">
                  <div className="availability-left">
                    <h2>
                      <i className="ti ti-calendar-event me-2"></i>
                      My Availability
                    </h2>

                    <p>
                      Manage your meeting schedule and block unavailable time
                      slots.
                    </p>
                  </div>

                  <div className="availability-actions">
                    <div className="date-card">
                      <span>Date</span>

                      <input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>

                    <div className="holiday-card">
                      <span>Holiday</span>

                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={isHoliday}
                          onChange={(e) => setIsHoliday(e.target.checked)}
                        />

                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>

                {/* <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="card bg-success text-white">
                      <div className="card-body">
                        <h4>
                          {allSlots.length -
                            new Set([
                              ...manualSlots,
                              ...meetingSlots.map((x) => x.time),
                            ]).size}
                        </h4>

                        <span>Available</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card bg-danger text-white">
                      <div className="card-body">
                        <h4>
                          {
                            new Set([
                              ...manualSlots,
                              ...meetingSlots.map((x) => x.time),
                            ]).size
                          }{" "}
                        </h4>

                        <span>Busy</span>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="availability-stats">
                  <div className="stat-box success">
                    <div>
                      <small>Available</small>

                      <h2>{availableSlots}</h2>
                    </div>

                    <i className="ti ti-check"></i>
                  </div>

                  <div className="stat-box danger">
                    <div>
                      <small>Busy</small>

                      <h2>{busySlots}</h2>
                    </div>

                    <i className="ti ti-lock"></i>
                  </div>

                  <div className="stat-box warning">
                    <div>
                      <small>Meetings</small>

                      <h2>{meetingSlots.length}</h2>
                    </div>

                    <i className="ti ti-calendar-event"></i>
                  </div>

                  <div className="stat-box primary">
                    <div>
                      <small>Status</small>

                      <h2>{isHoliday ? "Holiday" : "Working"}</h2>
                    </div>

                    <i className="ti ti-briefcase"></i>
                  </div>
                </div>

                <div className="availability-legend">
                  <span>
                    <div className="legend-dot green"></div>
                    Available
                  </span>

                  <span>
                    <div className="legend-dot red"></div>
                    Busy
                  </span>

                  <span>
                    <div className="legend-dot orange"></div>
                    Meeting
                  </span>
                </div>

                {renderSection("Morning", morning)}

                {renderSection("Afternoon", afternoon)}

                {renderSection("Evening", evening)}

                <div className="save-wrapper">
                  <button className="save-btn-modern" onClick={save}>
                    <i className="ti ti-device-floppy"></i>
                    Save Availability
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAvailability;
